import Manager from './ManagerActions';

const allActions = {
  Manager,
};

export default allActions;
